const updateFreightMatches = (rowIndex, columnID, value, old) => {
  if (columnID === "declined" && value) {
    return old.filter((row, index) => rowIndex !== index);
  } else {
    return old.map((row, index) => {
      if (index === rowIndex) {
        return {
          ...row,
          [columnID]: value,
        };
      }
      return row;
    });
  }
};


export {
  updateFreightMatches
};